<mat-dialog-content>
  <rpe-registro-actividad-maquinas-moviles-form #actividadMaquinaMovilForm
    (onMaquinaMovilChange)="onMaquinaMovilChange($event)" (onMaquinaMovilValid)="onMaquinaValidStatusChange($event)"
    [maquinaMovil]="data.maquinaMovil"></rpe-registro-actividad-maquinas-moviles-form>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="action">
    <button (click)="onCancel()" mat-raised-button>
      Cerrar
    </button>
    <button (click)="onAdd()" mat-raised-button>
      <span>
        Guardar
      </span>
    </button>
  </div>
</mat-dialog-actions>